import { updateData, save } from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_KEY } from '../FinancialAccountsWorkflowConstants';

const deleteAccount = (graphAccounts, id, workflowId, clientId) => (dispatch) => {
  dispatch(updateData(
    {
      [BACKEND_KEY]: graphAccounts.map((graphAccount) => {
        if (graphAccount.AccountId === id || graphAccount.frontEndId === id) {
          return {
            ...graphAccount,
            IsDeleted: true,
          };
        }
        return graphAccount;
      }),
    },
    workflowId,
    clientId,
  ));
  dispatch(save(BACKEND_KEY, () => {}, () => {}, workflowId, clientId, false));
};

export default deleteAccount;
